import { Loader } from '../Widgets';
import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { Session, User } from 'service';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';
import PaymentRequestImage from '../../assets/payment_request.png'
import BankBalanceImage from '../../assets/balance.png'
import DealersImage from '../../assets/dealers.png'
import GatepassImage from '../../assets/gatepass.png'
import LoadingImage from '../../assets/loading.png'
import { app_version, clearCache } from 'service/Utils';

export const Dashboard = () => {
    const userData = useSelector((state: RootState) => state.appdata);
    const [session, setSession] = useState<Session>();
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        if (userData.profile) {
            setSession(userData.profile.profile);
        }
    }, [userData]);

    useEffect(() => {
        if (session != null) {
            setIsLoading(false);
        }
    }, [session]);

    return (
        <>
            <div className="page-dashboard">
                {isLoading &&
                    <Loader />
                }
                {!isLoading &&
                    <>
                        {session && session.user && session.user.name &&
                            <div className='page-header bg-dark' style={{ paddingBottom: "20px", marginBottom: "20px" }}>
                                Welcome,
                                <h2>{session?.user.name}</h2>
                            </div>
                        }
                        <div className='row'>
                            {session?.activities && session?.activities.indexOf("view_bank_accounts") > -1 &&
                                <div className="col-lg-3 col-md-6 col-6 mb-4">
                                    <NavLink to="/bankAccounts">
                                        <div className="card">
                                            <img className="card-img-top" src={BankBalanceImage} alt="Card image cap"></img>
                                            <div className="card-body py-1">
                                                <h5 className="card-title">Bank Balances</h5>
                                            </div>
                                        </div>
                                    </NavLink>
                                </div>
                            }
                            {session?.activities && session?.activities.indexOf("approve_paymentRequest") > -1 &&
                                <div className="col-lg-3 col-md-6 col-6 mb-4">
                                    <NavLink to="/paymentRequest">
                                        <div className="card">
                                            <img className="card-img-top" src={PaymentRequestImage} alt="Card image cap"></img>
                                            <div className="card-body py-1">
                                                <h5 className="card-title">Payment Requests</h5>
                                            </div>
                                        </div>
                                    </NavLink>
                                </div>
                            }                            
                            {session?.activities && session?.activities.indexOf("approve_paymentRequest") > -1 &&
                                <div className="col-lg-3 col-md-6 col-6 mb-4">
                                    <NavLink to="/dealers">
                                        <div className="card">
                                            <img className="card-img-top" src={DealersImage} alt="Card image cap"></img>
                                            <div className="card-body py-1">
                                                <h5 className="card-title">Dealers</h5>
                                            </div>
                                        </div>
                                    </NavLink>
                                </div>
                            }
                             {session?.activities && session?.activities.indexOf("create_gatepass") > -1 &&
                                <div className="col-lg-3 col-md-6 col-6 mb-4">
                                    <NavLink to="/gatepass">
                                        <div className="card">
                                            <img className="card-img-top" src={GatepassImage} alt="Card image cap"></img>
                                            <div className="card-body py-1">
                                                <h5 className="card-title">Gatepasses</h5>
                                            </div>
                                        </div>
                                    </NavLink>
                                </div>
                            }
                             {session?.activities && session?.activities.indexOf("edit_loading_indent") > -1 &&
                                <div className="col-lg-3 col-md-6 col-6 mb-4">
                                    <NavLink to="/indents">
                                        <div className="card">
                                            <img className="card-img-top" src={LoadingImage} alt="Card image cap"></img>
                                            <div className="card-body py-1">
                                                <h5 className="card-title">Loading Indents</h5>
                                            </div>
                                        </div>
                                    </NavLink>
                                </div>
                            }
                            {(!session || !session.user || !session.user.name) &&
                                <div className='alert alert-danger'>
                                    You are not authorized to access this page. Please contact the administrator.
                                    { JSON.stringify(session?.user) }
                                </div>
                            }
                        </div>
                        <div className='row'>
                            <div className="col-12 mb-4">
                                <div style={{ position: "relative", height: 50 }}>
                                    <div className='version-number'>
                                        <div className="btn btn-sm bg-dark" style={{ marginBottom: 10, color: "#fff", float: "left" }} onClick={clearCache}>Update to latest version</div>
                                        <span style={{ float: "right" }} >{app_version}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                }
            </div>
        </>
    );
};